import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { WorkerFatturazioneDownloadFatturePRModalComponent } from './worker-download-fatture-pr-modal';

export const WorkerFatturazioneDownloadFatturePRModalModule: string = ng
    .module('worker-download-fatture-pr-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerFatturazioneDownloadFatturePRModalComponent', WorkerFatturazioneDownloadFatturePRModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pr/worker-download-fatture-pr-modal/worker-download-fatture-pr-modal.module.ts